import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap";
// import { useToast } from "@/components/ui/use-toast";
import classnames from "classnames";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";

import BasicInformation from "./basicInformation";
import ValidationCodes from "./validationInformation";
import PasswordInformation from "./passwordInformation";
import IdentityVerification from "./identityVerification";
import AddressVerification from "./addressVerification";
import FinancialInformation from "./financialInformation";
import CheckInformation from "./checkInformation";
import { Link, redirect, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  checkRegisterProgress,
  continueRegisterProgress,
  getRegisterEnded,
  postAddressInformation,
  postFinancialInformation,
  postIdentityVerification,
  registerIndividualFistStep,
  submitRegister,
} from "../../../helpers/AuthType/authBackend";
import { createPublicToken } from "../../../helpers/dataBackend";
import { setAuthorization } from "../../../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import LanguageDropdown from "Components/Common/LanguageDropdown";
import { useTranslation } from "react-i18next";

const StepsRegister = () => {
  //meta title
  document.title = "Ditobanx";
  const { t } = useTranslation();

  const dispatch = useDispatch<any>();
  const selectLayoutState = (state: any) => state.Layout;
  const selectProperties = createSelector(selectLayoutState, (layout) => ({
    layoutModeType: layout.layoutModeTypes,
  }));
  const { layoutModeType } = useSelector(selectProperties);

  const [color, setColor] = useState<string>("#fff");
  const [colorBase2, setColorBase2] = useState<string>("#e0e0e0");

  useEffect(() => {
    if (layoutModeType === "light") {
      // dispatch(
      //   changeLayoutMode(
      //     layoutModeType === LAYOUT_MODE_TYPES.DARK
      //       ? LAYOUT_MODE_TYPES.DARK
      //       : LAYOUT_MODE_TYPES.LIGHT
      //   )
      // );
      // setColor("#fff");
      // setColorBase2("#e0e0e0");
    } else {
      // dispatch(
      //   changeLayoutMode(
      //     layoutModeType === LAYOUT_MODE_TYPES.DARK
      //       ? LAYOUT_MODE_TYPES.LIGHT
      //       : LAYOUT_MODE_TYPES.DARK
      //   )
      // );
      // setColor("#212736");
      // setColorBase2("#2a3042");
    }
  }, [dispatch]);

  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [existingProcess, setExistingProcess] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [codeProcess, setCodeProcess] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);
  const tokenParam = searchParams.get("token");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showError, setShowError] = useState<boolean>(false);
  const navigate = useNavigate();
  const stepsName = [
    { code: "BRD", name: "Información Básica" },
    { code: "BRD", name: "Validación" },
    { code: "BRD", name: "Contraseña" },
    { code: "VI", name: "Verificación de identidad" },
    { code: "DR", name: "Dirección y residencia" },
    { code: "IF", name: "información Financiera" },
    { code: "RF", name: "Revisión y firma" },
  ];

  // Individual registration data
  const [individualData, setIndividualData] = useState<{
    basicInfo?: any;
    verificationOPT?: any;
    passwordInfo?: any;
    identityInfo?: any;
    addressInfo?: any;
    financialInfo?: any;
  }>({});

  const getPublicToken = async () => {
    const responsePublicToken = await createPublicToken();
    localStorage.setItem("publicToken", responsePublicToken.token);
    setAuthorization(responsePublicToken.token); // Guardar el token antes de continuar

    if (tokenParam) {
      const token = JSON.parse(atob(tokenParam.split(".")[1]));
      setCodeProcess(token.code);
      setUserId(token.userId);

      const maximoSteps = stepsName.length;

      if (token.exp * 1000 < Date.now()) {
        console.log("Token expired");
        // alert("Token expired");
        setTokenExpired(true);
      }

      stepsName.forEach((item, index) => {
        if (item.code === token.code) {
          if (index === maximoSteps - 1) {
            getFinalData(token.userId);
            // console.log("Datax", individualData);
          }
          setCurrentStep(index + 1);
        }
      });
    }
  };

  const getFinalData = async (userID: number) => {
    try {
      if (localStorage.getItem("publicToken")) {
        const response = await getRegisterEnded(userID);
        const responseData = JSON.parse(response.data);
        if (responseData) {
          setIndividualData({
            basicInfo: responseData.basicInfo,
            identityInfo: responseData.identityInfo,
            addressInfo: responseData.addressInfo,
            financialInfo: responseData.financialInfo,
          });
        }
      }
    } catch (error) {
      console.log("Hubo un problema al guardar la información.");
      console.log(error);
    }
  };

  useEffect(() => {
    getPublicToken();
  }, [tokenParam]);

  const handleContinueProcess = async () => {
    setBtnDisabled(true);
    try {
      const response = await continueRegisterProgress({
        email: individualData.basicInfo.email,
      });
      // console.log("Response", { response });

      setExistingProcess(false); // Cierra modal actual
      setShowConfirmationModal(true); // Abre nuevo modal
    } catch (error) {
      console.error("Error al continuar:", error);
      setBtnDisabled(false);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmationModal(false);
    // handlePrintData(); // Si deseas imprimir datos luego
  };

  const [passedSteps, setPassedSteps] = useState([1]);

  const nextStep = () => {
    const maxSteps = stepsName.length;
    if (currentStep === maxSteps) {
      redirect("/individual-confirmation");
    }
    if (currentStep < maxSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
    window.scrollTo(0, 0);
  };

  const handleCloseError = () => {
    setShowError(false);
    // handleDataPrint(); // Si deseas imprimir datos luego
  };

  // Individual form handlers
  const handleBasicInfoSubmit = async (data: any) => {
    setIndividualData({ ...individualData, basicInfo: data });
    const response = await checkRegisterProgress({ email: data.email });
    const dataResponse = JSON.parse(response.data);
    if (dataResponse.currentStatus?.code === "RC") {
      setErrorMessage(
        `El registro con el correo ${data.email} ya se encuentra completo`
      );
      setShowError(true);
      return;
    }
    if (
      dataResponse.currentStatus?.code &&
      dataResponse.currentStatus?.code !== "RC"
    ) {
      setExistingProcess(true); // Abre modal de confirmación
    } else {
      toast.success("Tus datos personales han sido guardados exitosamente.");
      nextStep();
    }
  };

  const handleOTPVerificationInfoSubmit = (data: any) => {
    setIndividualData({ ...individualData, verificationOPT: data });
    toast.success("Tus datos personales han sido guardados exitosamente.");
    nextStep();
  };

  const handlePasswordInfoSubmit = async (data: any) => {
    setIndividualData({ ...individualData, passwordInfo: data });
    try {
      const response = await registerIndividualFistStep({
        basicInfo: individualData.basicInfo,
        passwordInfo: data,
      });

      const userData = JSON.parse(response.data);
      if (userData?.error === true) {
        setErrorMessage(userData?.message);
        setShowError(true);
      }

      setUserId(userData.id);
      if (response.status === true) {
        toast.success("Tus datos personales han sido guardados exitosamente.");
        nextStep();
      } else {
        toast.error("Hubo un problema al guardar la información.");
      }
    } catch (error: any) {
      console.log("Hubo un problema al guardar la información.");
      console.log(error);
    }
  };

  const handleIdentityInfoSubmit = async (data: any) => {
    setIndividualData({ ...individualData, identityInfo: data });

    try {
      const { document1, selfie, document_back, document_front, ...info } =
        data;

      // Función auxiliar para subir imágenes con manejo de errores
      // const tryUpload = async (field: string, file: any) => {
      //   try {
      //     if (file?.base64) {
      //       await saveImages({ userId: userId, [field]: file });
      //     }
      //   } catch (err: any) {
      //     console.warn(`Error al subir ${field}:`, err.message);
      //   }
      // };

      // Subida de imágenes (verifica que estén y tengan base64)
      // await tryUpload("selfie", document_back); // Parece invertido en tu original
      // await tryUpload("document_front", selfie);
      // await tryUpload("document_back", document1);

      // Continúa con la verificación de identidad
      const response = await postIdentityVerification({
        userId: userId,
        identityInfo: info,
      });

      const userData = JSON.parse(response.data);
      if (userData?.error === true) {
        setErrorMessage(userData?.message);
        setShowError(true);
      }
      if (userData.id) {
        nextStep();
      }
    } catch (error: any) {
      console.log("Hubo un problema al guardar la información.");
      console.log(error.response);
      alert("No se puede editar este paso.");
    }
  };

  const handleAddressInfoSubmit = async (data: any) => {
    setIndividualData({ ...individualData, addressInfo: data });

    try {
      const response = await postAddressInformation({
        userId: userId,
        addressInfo: data,
      });
      const userData = JSON.parse(response.data);
      console.log(userData);
      if (userData?.error === true) {
        setErrorMessage(userData?.message);
        setShowError(true);
      }
      if (userData.id) {
        toast.success(
          "Tus datos de direccion han sido guardados exitosamente."
        );
        nextStep();
      }
    } catch (error: any) {
      console.log("Hubo un problema al guardar la información.");
      console.log(error.response);
      alert("No se puede editar este paso.");
    }
  };

  const handleFinancialInfoSubmit = async (data: any) => {
    setIndividualData({ ...individualData, financialInfo: data });

    try {
      const response = await postFinancialInformation({
        userId: userId,
        financialInfo: data,
      });
      const userData = JSON.parse(response.data);
      if (userData?.error === true) {
        setErrorMessage(userData?.message);
        setShowError(true);
      }
      if (userData.id) {
        toast.success("Tus datos financieros han sido guardados exitosamente.");
        getFinalData(Number(userId));
        nextStep();
      }
    } catch (error: any) {
      console.log("Hubo un problema al guardar la información.");
      console.log(error.response);
      alert("No se puede editar este paso.");
    }
  };

  const handleReviewSubmit = async (data: any) => {
    try {
      const response = await submitRegister({
        userId: userId,
        checkInfo: data,
      });
      toast.success("Tus datos personales han sido guardados exitosamente.");
      navigate("/individual-confirmation");
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <button onClick={handlePrintData}>Imprimir data</button> */}
          <Row className="justify-content-center mt-lg-5">
            <Col xl={8} sm={8} md={10} lg={8}>
              <Card>
                <CardBody>
                  <div id="kyc-verify-wizard" className="wizard clearfix">
                    <div
                      className="steps clearfix"
                      style={{
                        display: "flex",
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                        backgroundColor: color,
                        borderRadius: "5px",
                        padding: "10px",
                        // gap: "10px",
                        scrollbarWidth: "thin",
                      }}
                    >
                      {stepsName.map((item: any, index: any) => (
                        <div
                          className={classnames({
                            current: currentStep === index + 1,
                          })}
                          style={{
                            flex: "0 0 auto",
                            minWidth: "120px",
                            // maxWidth: "160px",
                            width: `${100 / stepsName.length}%`,
                            backgroundColor:
                              currentStep === index + 1
                                ? colorBase2 //
                                : "transparent",
                            textAlign: "center",
                            borderRadius: "5px",
                            padding: "5px",
                          }}
                        >
                          <NavLink
                            className={classnames({
                              active: currentStep === index + 1,
                            })}
                            disabled={!passedSteps.includes(index + 1)}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                            }}
                          >
                            <span className="number">{index + 1}</span>
                            <p style={{ margin: 0 }}>{item.name}</p>
                          </NavLink>
                        </div>
                      ))}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "10px",
                      }}
                    >
                      <LanguageDropdown />
                    </div>
                    <div className="content clearfix">
                      <TabContent
                        activeTab={currentStep}
                        className="twitter-bs-wizard-tab-content"
                      >
                        {/* BASIC INFORMATION */}
                        {currentStep === 1 && (
                          <TabPane
                            tabId={1}
                            id="personal-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Natural Person register")}</p>
                              {/* {t("Select")} */}
                            </div>
                            <BasicInformation
                              onSubmit={handleBasicInfoSubmit}
                              onBack={prevStep}
                              data={individualData}
                            />
                          </TabPane>
                        )}
                        {/* VALIDACION */}
                        {currentStep === 2 && (
                          <TabPane
                            tabId={2}
                            id="validation"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Step2-registerPerson")}</p>
                            </div>
                            <ValidationCodes
                              onSubmit={handleOTPVerificationInfoSubmit}
                              onBack={prevStep}
                              data={individualData}
                            />
                          </TabPane>
                        )}
                        {/* PASSWORD */}
                        {currentStep === 3 && (
                          <TabPane
                            tabId={3}
                            id="password-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Step3-registerPerson")}</p>
                            </div>
                            <PasswordInformation
                              onSubmit={handlePasswordInfoSubmit}
                              onBack={prevStep}
                              data={individualData}
                            />
                          </TabPane>
                        )}
                        {/* VERIFICACION IDENTIDAD */}
                        {currentStep === 4 && (
                          <TabPane
                            tabId={4}
                            id="identity-verification"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Identity Verification")}</p>
                            </div>
                            <IdentityVerification
                              onSubmit={handleIdentityInfoSubmit}
                              onBack={prevStep}
                              data={individualData}
                              userId={userId}
                            />
                          </TabPane>
                        )}
                        {/* ADDRESS INFO */}
                        {currentStep === 5 && (
                          <TabPane
                            tabId={5}
                            id="address-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Natural Person register")}</p>
                            </div>
                            <AddressVerification
                              onSubmit={handleAddressInfoSubmit}
                              onBack={prevStep}
                              data={individualData}
                              userId={userId}
                            />
                          </TabPane>
                        )}
                        {/* FINANCIAL INFO */}
                        {currentStep === 6 && (
                          <TabPane
                            tabId={6}
                            id="financial-info"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Finantial Information")}</p>
                            </div>
                            <FinancialInformation
                              onSubmit={handleFinancialInfoSubmit}
                              onBack={prevStep}
                              data={individualData}
                            />
                          </TabPane>
                        )}
                        {/* CHECOUT */}
                        {currentStep === 7 && (
                          <TabPane
                            tabId={7}
                            id="checkout"
                            className="body current"
                          >
                            <div style={{ marginBottom: "30px" }}>
                              <h1>{stepsName[currentStep - 1].name}</h1>
                              <p>{t("Natural Person register")}</p>
                            </div>
                            <CheckInformation
                              onSubmit={handleReviewSubmit}
                              onBack={prevStep}
                              data={individualData}
                            />
                          </TabPane>
                        )}
                      </TabContent>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* MODAL PARA CONTINUAR EL PROCESO */}
      {existingProcess && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¿Continuar proceso?</h2>
            <p style={styles.modalText}>
              Ya existe un proceso en curso. ¿Deseas continuar donde lo dejaste?
            </p>
            <div style={styles.buttonGroup}>
              <button
                style={styles.cancelButton}
                onClick={() => setExistingProcess(false)}
              >
                Cancelar
              </button>
              <button
                style={styles.confirmButton}
                onClick={handleContinueProcess}
                disabled={btnDisabled}
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación */}
      {showConfirmationModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¡Correo enviado!</h2>
            <p style={styles.modalText}>
              Hemos enviado un enlace a tu correo electrónico. Ya puedes cerrar
              esta página y continuar el registro con el enlace compartido.
            </p>
            <div style={{ marginTop: "20px" }}>
              <button
                style={styles.confirmButton}
                onClick={handleCloseConfirmation}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación */}
      {tokenExpired && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>El Token ha expirado!</h2>
            <p style={styles.modalText}>
              Seras redirigido a la pagina de inicio de sesion.
            </p>
            <div style={{ marginTop: "20px" }}>
              <Link to="/login" style={styles.confirmButton}>
                <span>Aceptar</span>
              </Link>
            </div>
          </div>
        </div>
      )}

      {showError && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¡Hubo un Problema!</h2>
            <p style={styles.modalText}>{errorMessage}</p>
            <div style={{ marginTop: "20px" }}>
              <button style={styles.confirmButton} onClick={handleCloseError}>
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalBox: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    width: "90%",
    maxWidth: "400px",
    minWidth: "280px",
    textAlign: "center",
  },
  modalTitle: {
    marginBottom: "15px",
    color: "#333",
  },
  modalText: {
    color: "#555",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    gap: "10px",
  },
  cancelButton: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#e0e0e0",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
  confirmButton: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default StepsRegister;
